import { defineQuartzConfig } from 'quartz-config';
export default defineQuartzConfig({
  loadWhisperCore: false,
  type: 'application',
  auth: 'none',
  additionalDlbs: ['apollo-dlb/bundle.js'],
  logFetchErrors: {
    options: {
      ignoreErrors: []
    }
  },
  icons: null,
  htmlTitle: 'Customer Portal Application',
  htmlTitleLangKey: 'app.htmlTitle',
  historyBasename: '/:basename'
});